import { IconButtonIconType } from '@doordash/component-button';
import { TextAlignment } from '@doordash/design-language';

var NavBarNavigationType = {
  Back: {
    icon: IconButtonIconType.ArrowLeft,
    accessibilityLabel: 'Back'
  },
  Menu: {
    icon: IconButtonIconType.Menu,
    accessibilityLabel: 'Menu'
  },
  Close: {
    icon: IconButtonIconType.Close,
    accessibilityLabel: 'Close'
  },
  None: 'None'
};
var NavBarTextAlignment = {
  Left: TextAlignment.Left,
  Center: TextAlignment.Center
};

export { NavBarNavigationType, NavBarTextAlignment };
